const translationsFr = {
  mercure: {
    rates: {
      welcomeMessage: "Bienvenue au Mercure<br>{hotelName}",
      roomRatesTitle: "prix des prestations",
      dayRate: "Prix du jour"
    }
  },
  barriere: {
    change: {
      title: "cours de change",
      updateDate: "Date d'actualisation"
    }
  },
  ibis: {
    rates: {
      additionalServices: "Prestations annexes",
      additionalServicesSubtitle: "tarifs à consulter en réception"
    }
  },
  novotel: {
    rates: {
      roomRatesTitle: "prix des prestations",
      dayRate: "Prix du jour"
    }
  },
  tribe: {
    rates: {
      roomRatesTitle: "prix des prestations",
      memberCard: "Carte membre",
      dayRate: "Prix du jour"
    }
  }
};

export default translationsFr;



// WEBPACK FOOTER //
// ./src/tools/i18n/fr.js